const clientLogger = console;

export { clientLogger };
